import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ShieldCheck, ArrowRight, Lock, EyeOff, Scale } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fadeUp } from "./anim";

export const LandingHero = () => (
  <section className="hero-gradient noise-overlay">
    <div className="mx-auto max-w-6xl px-4 pb-16 pt-14 sm:px-6 sm:pt-20">
      <motion.div {...fadeUp} className="mx-auto max-w-3xl text-center">
        <span className="inline-flex items-center gap-2 rounded-full border bg-card px-3 py-1 text-xs font-medium text-muted-foreground">
          <ShieldCheck className="h-3.5 w-3.5 text-[hsl(var(--risk-low))]" /> Built for Australian short-stay hosts
        </span>
        <h1 className="mt-5 font-display text-4xl font-semibold tracking-tight text-foreground sm:text-5xl lg:text-6xl" data-testid="hero-headline">
          Protect your Airbnb business before a risky booking costs you thousands.
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">
          Assess every booking&apos;s risk, generate host-protection evidence, and book with confidence &mdash; the
          compliant way. HostGuard scores the booking, never the person.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link to="/signup"><Button size="lg" className="gap-2" data-testid="hero-signup-button">Create Free Account <ArrowRight className="h-4 w-4" /></Button></Link>
          <a href="#how"><Button size="lg" variant="outline" data-testid="hero-how-button">How It Works</Button></a>
        </div>
        <p className="mt-4 flex flex-wrap items-center justify-center gap-4 text-xs text-muted-foreground">
          <span className="flex items-center gap-1"><EyeOff className="h-3.5 w-3.5" /> No guest names</span>
          <span className="flex items-center gap-1"><Lock className="h-3.5 w-3.5" /> Private to your account</span>
          <span className="flex items-center gap-1"><Scale className="h-3.5 w-3.5" /> No blacklists</span>
        </p>
      </motion.div>
    </div>
  </section>
);
